import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { MedicoControleAdministrativoService } from '@/core/api/sicom-api/registro/medico/controle-administrativo/medico-controle-administrativo.service';
import { MedicoCadastroGeralResponse } from '@/core/api/sicom-api/registro/medico/controle-administrativo/medico-cadastro-geral.model';
import { MedicoEstatisticaAgrupadaResponse } from '@/core/api/sicom-api/registro/medico/controle-administrativo/medico-estatistica-agrupada.model';
import { MedicoSituacaoEnderecoTipoResponse } from '@/core/api/sicom-api/registro/medico/controle-administrativo/medico-situacao-endereco-tipo.model';
import { MedicoPendenciaResponse } from '@/core/api/sicom-api/registro/medico/pendencia/medico-pendencia.model';
import { Page } from '@/shared/models/page.model';
import { CustomService } from '@/shared/services/custom.service';

@Injectable({ providedIn: 'root' })
export class MedicoControleAdministrativoFeatureService extends CustomService {
    constructor(private core: MedicoControleAdministrativoService) {
        super();
    }

    consultarTotalInscricaoPrincipal(uf?: string): Observable<number> {
        return this.core.consultarTotalInscricaoPrincipal(uf).pipe(catchError(this.handleError));
    }

    consultarTotalInscricaoSecundaria(uf?: string): Observable<number> {
        return this.core.consultarTotalInscricaoSecundaria(uf).pipe(catchError(this.handleError));
    }

    consultarTotalInscricaoProvisoria(uf?: string): Observable<number> {
        return this.core.consultarTotalInscricaoProvisoria(uf).pipe(catchError(this.handleError));
    }

    consultarTotalTransferenciasConcedidas(uf?: string): Observable<number> {
        return this.core.consultarTotalTransferenciasConcedidas(uf).pipe(catchError(this.handleError));
    }

    consultarTotalBaixasExercicioProfissional(uf?: string): Observable<number> {
        return this.core.consultarTotalBaixasExercicioProfissional(uf).pipe(catchError(this.handleError));
    }

    consultarTotalCancelamentosInscricao(uf?: string): Observable<number> {
        return this.core.consultarTotalCancelamentosInscricao(uf).pipe(catchError(this.handleError));
    }

    consultarTotalTitulosEspecialistaEmitidos(uf?: string): Observable<number> {
        return this.core.consultarTotalTitulosEspecialistaEmitidos(uf).pipe(catchError(this.handleError));
    }

    consultarUltimoCrmCadastrado(uf?: string): Observable<number> {
        return this.core.consultarUltimoCrmCadastrado(uf).pipe(catchError(this.handleError));
    }

    consultarNovasInscricoesPorMes(uf?: string, ano?: number): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarNovasInscricoesPorMes(uf, ano).pipe(catchError(this.handleError));
    }

    consultarDistribuicaoFaixaEtaria(uf?: string): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarDistribuicaoFaixaEtaria(uf).pipe(catchError(this.handleError));
    }

    consultarDistribuicaoGenero(uf?: string): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarDistribuicaoGenero(uf).pipe(catchError(this.handleError));
    }

    consultarMedicosPorMunicipio(uf?: string, limite?: number): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarMedicosPorMunicipio(uf, limite).pipe(catchError(this.handleError));
    }

    consultarFormadosExteriorPorPais(uf?: string, limite?: number): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarFormadosExteriorPorPais(uf, limite).pipe(catchError(this.handleError));
    }

    consultarEspecialidadesMaisRegistradas(uf?: string, limite?: number): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarEspecialidadesMaisRegistradas(uf, limite).pipe(catchError(this.handleError));
    }

    consultarTempoMedioFormaturaPrimeiraInscricao(uf?: string): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarTempoMedioFormaturaPrimeiraInscricao(uf).pipe(catchError(this.handleError));
    }

    consultarConversaoInscricaoProvisoria(uf?: string): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarConversaoInscricaoProvisoria(uf).pipe(catchError(this.handleError));
    }

    consultarTransferenciasOrigemDestino(uf?: string, limite?: number): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarTransferenciasOrigemDestino(uf, limite).pipe(catchError(this.handleError));
    }

    consultarTempoMedioTramitacaoTransferencia(uf?: string): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarTempoMedioTramitacaoTransferencia(uf).pipe(catchError(this.handleError));
    }

    consultarMovimentacaoSituacaoCadastral(uf?: string, ano?: number, limite?: number): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarMovimentacaoSituacaoCadastral(uf, ano, limite).pipe(catchError(this.handleError));
    }

    consultarTempoMedioSituacaoCadastral(uf?: string, limite?: number): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarTempoMedioSituacaoCadastral(uf, limite).pipe(catchError(this.handleError));
    }

    consultarDocumentosAusentes(uf?: string): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarDocumentosAusentes(uf).pipe(catchError(this.handleError));
    }

    consultarCadastrosPorAtualizacao(uf?: string): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarCadastrosPorAtualizacao(uf).pipe(catchError(this.handleError));
    }

    consultarContatosValidos(uf?: string): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarContatosValidos(uf).pipe(catchError(this.handleError));
    }

    consultarDuplicidadesPotenciais(uf?: string): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarDuplicidadesPotenciais(uf).pipe(catchError(this.handleError));
    }

    consultarRankingFaculdadesFormacao(uf?: string, limite?: number): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarRankingFaculdadesFormacao(uf, limite).pipe(catchError(this.handleError));
    }

    consultarMedicosSemEspecialidade(uf?: string): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarMedicosSemEspecialidade(uf).pipe(catchError(this.handleError));
    }

    consultarMediaEspecialidadesPorMedico(uf?: string): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarMediaEspecialidadesPorMedico(uf).pipe(catchError(this.handleError));
    }

    consultarSubgruposEspeciais(uf?: string): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarSubgruposEspeciais(uf).pipe(catchError(this.handleError));
    }

    consultarCancelamentosPorSituacao(uf?: string, ano?: number, limite?: number): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarCancelamentosPorSituacao(uf, ano, limite).pipe(catchError(this.handleError));
    }

    consultarReinscricoesAposCancelamento(uf?: string, ano?: number): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarReinscricoesAposCancelamento(uf, ano).pipe(catchError(this.handleError));
    }

    consultarProtocolosMedicoPorTipo(uf?: string, ano?: number, limite?: number): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarProtocolosMedicoPorTipo(uf, ano, limite).pipe(catchError(this.handleError));
    }

    consultarEmissoesDocumentais(uf?: string, ano?: number): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarEmissoesDocumentais(uf, ano).pipe(catchError(this.handleError));
    }

    consultarCadastrosAtualizadosPorMes(uf?: string, ano?: number): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarCadastrosAtualizadosPorMes(uf, ano).pipe(catchError(this.handleError));
    }

    consultarAnotacoesAdministrativas(uf?: string, ano?: number): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarAnotacoesAdministrativas(uf, ano).pipe(catchError(this.handleError));
    }

    consultarDistribuicaoPorSituacao(uf?: string): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarDistribuicaoPorSituacao(uf).pipe(catchError(this.handleError));
    }

    consultarTelemedicinaTipos(uf?: string): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarTelemedicinaTipos(uf).pipe(catchError(this.handleError));
    }

    consultarDeficienciaTipos(uf?: string): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarDeficienciaTipos(uf).pipe(catchError(this.handleError));
    }

    consultarPosGraduacaoTipos(uf?: string): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarPosGraduacaoTipos(uf).pipe(catchError(this.handleError));
    }

    consultarPosGraduacaoInstituicoes(uf?: string, limite?: number): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarPosGraduacaoInstituicoes(uf, limite).pipe(catchError(this.handleError));
    }

    consultarConflitoInteresseSituacao(uf?: string): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarConflitoInteresseSituacao(uf).pipe(catchError(this.handleError));
    }

    consultarPcmsoRiscos(uf?: string, limite?: number): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarPcmsoRiscos(uf, limite).pipe(catchError(this.handleError));
    }

    consultarVistosVencimentoFaixa(uf?: string): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarVistosVencimentoFaixa(uf).pipe(catchError(this.handleError));
    }

    consultarProjecaoAposentadoria(uf?: string): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarProjecaoAposentadoria(uf).pipe(catchError(this.handleError));
    }

    consultarRetencaoFormados(uf?: string): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarRetencaoFormados(uf).pipe(catchError(this.handleError));
    }

    consultarIdadeMediaEspecialidade(uf?: string, limite?: number): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarIdadeMediaEspecialidade(uf, limite).pipe(catchError(this.handleError));
    }

    consultarTempoInscricaoTitulo(uf?: string, limite?: number): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarTempoInscricaoTitulo(uf, limite).pipe(catchError(this.handleError));
    }

    consultarEvolucaoAnualAtivos(uf?: string): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarEvolucaoAnualAtivos(uf).pipe(catchError(this.handleError));
    }

    consultarInteriorizacaoAnual(uf?: string): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarInteriorizacaoAnual(uf).pipe(catchError(this.handleError));
    }

    consultarTempoMedioAtendimentoProtocolo(uf?: string, ano?: number, limite?: number): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarTempoMedioAtendimentoProtocolo(uf, ano, limite).pipe(catchError(this.handleError));
    }

    consultarSituacaoMensalSituacao(uf?: string): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarSituacaoMensalSituacao(uf).pipe(catchError(this.handleError));
    }

    consultarSituacaoMensalSexo(uf?: string): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarSituacaoMensalSexo(uf).pipe(catchError(this.handleError));
    }

    consultarSituacaoMensalMovimento(uf?: string, mes?: number, ano?: number): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarSituacaoMensalMovimento(uf, mes, ano).pipe(catchError(this.handleError));
    }

    consultarSituacaoMensalCancelamentos(uf?: string, mes?: number, ano?: number): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarSituacaoMensalCancelamentos(uf, mes, ano).pipe(catchError(this.handleError));
    }

    consultarSituacaoMensalEnderecoTipo(uf?: string): Observable<MedicoSituacaoEnderecoTipoResponse[]> {
        return this.core.consultarSituacaoMensalEnderecoTipo(uf).pipe(catchError(this.handleError));
    }

    consultarSituacaoPorMes(uf?: string, ano?: number): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarSituacaoPorMes(uf, ano).pipe(catchError(this.handleError));
    }

    consultarSituacaoMensalMedicos(cardId: string, uf?: string | null, mes?: number, ano?: number, page?: number, size?: number, codigo?: string | null): Observable<Page<MedicoPendenciaResponse>> {
        return this.core.consultarSituacaoMensalMedicos(cardId, uf, mes, ano, page, size, codigo).pipe(catchError(this.handleError));
    }

    consultarTotalMedicosAtivosNaData(uf: string | undefined, data: string): Observable<number> {
        return this.core.consultarTotalMedicosAtivosNaData(uf, data).pipe(catchError(this.handleError));
    }

    consultarMedicosAtivosNaData(uf: string | undefined, data: string, page?: number, size?: number): Observable<Page<MedicoPendenciaResponse>> {
        return this.core.consultarMedicosAtivosNaData(uf, data, page, size).pipe(catchError(this.handleError));
    }

    consultarCadastroGeral(inscricao?: string, genero?: string): Observable<MedicoCadastroGeralResponse[]> {
        return this.core.consultarCadastroGeral(inscricao, genero).pipe(catchError(this.handleError));
    }

    consultarIsencoesPorMotivo(uf?: string): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarIsencoesPorMotivo(uf).pipe(catchError(this.handleError));
    }

    consultarTermoLgpd(uf?: string): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarTermoLgpd(uf).pipe(catchError(this.handleError));
    }

    consultarVistosConcedidosPorTipo(uf?: string): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarVistosConcedidosPorTipo(uf).pipe(catchError(this.handleError));
    }

    consultarOcorrenciasPorTipo(uf?: string, limite?: number): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarOcorrenciasPorTipo(uf, limite).pipe(catchError(this.handleError));
    }

    consultarDiplomasApresentacao(uf?: string): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarDiplomasApresentacao(uf).pipe(catchError(this.handleError));
    }

    consultarEstadoCivil(uf?: string): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarEstadoCivil(uf).pipe(catchError(this.handleError));
    }

    consultarTipoSanguineo(uf?: string, limite?: number): Observable<MedicoEstatisticaAgrupadaResponse[]> {
        return this.core.consultarTipoSanguineo(uf, limite).pipe(catchError(this.handleError));
    }

    consultarMedicosEstatisticaCadastro(estatisticaId: string, uf?: string | null, ano?: number, page?: number, size?: number, codigo?: string | null): Observable<Page<MedicoPendenciaResponse>> {
        return this.core.consultarMedicosEstatisticaCadastro(estatisticaId, uf, ano, page, size, codigo).pipe(catchError(this.handleError));
    }
}
